import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetSubmittedTrustdockDataRequest,
  DefaultApiAddOrganizationCreateRequestRequest,
  DefaultApiDeleteOrganizationCreateRequestRequest,
  DefaultApiCheckDuplicateEmailAddressesRequest,
} from '@src/api/generated/user-api'

export const getSubmittedTrustdockData = async (
  instance: AxiosInstance,
  params: DefaultApiGetSubmittedTrustdockDataRequest
) => {
  return await userApiDefaultApiFactory(instance).getSubmittedTrustdockData(
    params
  )
}

export const addOrganizationCreateRequest = async (
  instance: AxiosInstance,
  params: DefaultApiAddOrganizationCreateRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).addOrganizationCreateRequest(
    params
  )
}

export const deleteOrganizationCreateRequest = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteOrganizationCreateRequestRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).deleteOrganizationCreateRequest(params)
}

export const checkDuplicateEmailAddresses = async (
  instance: AxiosInstance,
  params: DefaultApiCheckDuplicateEmailAddressesRequest
) => {
  return await userApiDefaultApiFactory(instance).checkDuplicateEmailAddresses(
    params
  )
}

// Do Not Remove this line ===@import api client===
